import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import './App.css';
import './i18n';

// Layout Components
import Layout from './components/Layout';
import Login from './components/Login';

// Dashboard
import Dashboard from './components/Dashboard';

// System Management
import SystemSettings from './components/SystemSettings';
import MasterDataManagement from './components/MasterDataManagement';
import SystemMonitoring from './components/SystemMonitoring';
import SystemLogs from './components/SystemLogs';

// Tenant Management
import TenantManagement from './components/TenantManagement';
import TenantDetails from './components/TenantDetails';
import TenantDockerManagement from './components/TenantDockerManagement';
import TenantBackupManagement from './components/TenantBackupManagement';

// User Management
import UserManagement from './components/UserManagement';
import UserRoles from './components/UserRoles';
import SystemUsers from './components/SystemUsers';

// Integration Management
import IntegrationManagement from './components/IntegrationManagement';
import POSIntegration from './components/POSIntegration';
import TecDocIntegration from './components/TecDocIntegration';
import EInvoiceIntegration from './components/EInvoiceIntegration';
import AccountingIntegration from './components/AccountingIntegration';

// AI Management
import AIManagement from './components/AIManagement';
import AIQueryInterface from './components/AIQueryInterface';
import AIModelManagement from './components/AIModelManagement';

// Reports & Analytics
import SystemReports from './components/SystemReports';
import SystemAnalytics from './components/SystemAnalytics';

// Context
import { AuthProvider, useAuth } from './context/AuthContext';
import { SystemProvider } from './context/SystemContext';

function App() {
  return (
    <AuthProvider>
      <SystemProvider>
        <Router>
          <AppContent />
        </Router>
      </SystemProvider>
    </AuthProvider>
  );
}

function AppContent() {
  const { isAuthenticated, user } = useAuth();

  if (!isAuthenticated) {
    return <Login />;
  }

  return (
    <Layout>
      <Routes>
        <Route path="/" element={<Navigate to="/dashboard" replace />} />
        <Route path="/dashboard" element={<Dashboard />} />
        
        {/* System Management */}
        <Route path="/system-settings" element={<SystemSettings />} />
        <Route path="/master-data" element={<MasterDataManagement />} />
        <Route path="/monitoring" element={<SystemMonitoring />} />
        <Route path="/system-logs" element={<SystemLogs />} />
        
        {/* Tenant Management */}
        <Route path="/tenants" element={<TenantManagement />} />
        <Route path="/tenants/:tenantId" element={<TenantDetails />} />
        <Route path="/tenants/:tenantId/docker" element={<TenantDockerManagement />} />
        <Route path="/tenants/:tenantId/backup" element={<TenantBackupManagement />} />
        
        {/* User Management */}
        <Route path="/users" element={<UserManagement />} />
        <Route path="/user-roles" element={<UserRoles />} />
        <Route path="/system-users" element={<SystemUsers />} />
        
        {/* Integration Management */}
        <Route path="/integrations" element={<IntegrationManagement />} />
        <Route path="/integrations/pos" element={<POSIntegration />} />
        <Route path="/integrations/tecdoc" element={<TecDocIntegration />} />
        <Route path="/integrations/einvoice" element={<EInvoiceIntegration />} />
        <Route path="/integrations/accounting" element={<AccountingIntegration />} />
        
        {/* AI Management */}
        <Route path="/ai" element={<AIManagement />} />
        <Route path="/ai/query" element={<AIQueryInterface />} />
        <Route path="/ai/models" element={<AIModelManagement />} />
        
        {/* Reports & Analytics */}
        <Route path="/reports" element={<SystemReports />} />
        <Route path="/analytics" element={<SystemAnalytics />} />
      </Routes>
    </Layout>
  );
}

export default App; 